<template>
  <div>
    <div v-show="!loading" v-if="!loading">
      <table-cadu
        nameTab="pendencia"
        :class="$vuetify.breakpoint.xs ? 'pendencia-mobile' : 'pendencia'"
        v-model="selected"
        custom
        :disabledButtons="[true, false, false, false, true]"
        :showFiltro="false"
        :showCheck="false"
        :rows="rows"
        :rowsHeader="rowsHeader"
        :qtResultados="rows.length"
        :pagina="pagina"
        :qtPaginas="quantidadesPaginas"
        :elementsPerPageProp="this.elementosPorPagina"
        :items="['05', '10', '15']"
        :loading="loading"
        :editar="true"
        @clickButton="(objeto) => visualizar(objeto)"
        @change-element="(element) => changeSelect(element)"
        @change-page="(page) => changePage(page.currentPage)"
        @ordena="(obj) => changeOrdem(obj)"
        @indexHeader="(index) => ordenacao(index)"
      ></table-cadu>
    </div>
    <component-loading :value="loading" />
    <error-modal v-model="showError" :errObj="errObj" />
  </div>
</template>

<script>
import Pendencia from '../../../services/Pendencia/Pendencia'

export default {
  props: {
    carregar: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      selected: [],

      // Table Pendencia
      rowsHeader: [
        { text: 'Código', icon: 'repeat' },
        { text: 'Unimed', icon: 'repeat' },
        { text: 'Login', icon: 'repeat' },
        { text: 'Usuário', icon: 'repeat' },
        { text: 'Data', icon: 'repeat' }
      ],
      pagina: 1,
      rows: [],
      quantidadesPaginas: 1,
      resultadosPaginas: 10,
      elementosPorPagina: 5,
      ordem: 'desc',
      indexHeader: 'dataCriacao',

      loading: true,

      showError: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      }
    }
  },

  async created() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    await this.getPendencia()
  },

  methods: {
    changeSelect(element) {
      if (element.elementsPerPage !== this.rows.length && this.pagina < this.quantidadesPaginas) {
        this.elementosPorPagina = element
        this.getPendencia(this.args())
      } else {
        this.pagina = 1
        this.elementosPorPagina = element
        this.getPendencia(this.args())
      }
    },

    changePage(page) {
      this.pagina = page
      this.getPendencia(this.args())
    },

    visualizar(objeto) {
      if (objeto.type === 'view') {
        this.$emit('visualizar', this.rows[objeto.index])
      }
      if (objeto.type === 'anexo') {
        this.$emit('anexo', this.rows[objeto.index].id)
      }
    },

    changeOrdem(obj) {
      this.ordem = this.ordem === 'asc' ? 'desc' : 'asc'
      switch (obj.index) {
        case 0:
          this.indexHeader = 'codigo'
          break
        case 1:
          this.indexHeader = 'unimed'
          break
        case 2:
          this.indexHeader = 'usuarioCaduCriacao.login'
          break
        case 3:
          this.indexHeader = 'usuarioCaduCriacao.nome'
          break
        case 4:
          this.indexHeader = 'dataCriacao'
          break
      }
      this.getPendencia(this.args())
    },

    args() {
      return `?direcaoOrdenacao=${this.ordem}&ordenacao=${this.indexHeader}&pagina=${this.pagina}&tamanhoPagina=${this.elementosPorPagina}`
    },

    async getPendencia(args = '') {
      this.loading = true
      let pendencia = new Pendencia(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      try {
        let responseGet = await pendencia.getPendencia(args)
        this.rows = responseGet.data.conteudo
        this.loading = false
        this.pagina = responseGet.data.pagina
        this.quantidadesPaginas = responseGet.data.qtPaginas
      } catch (err) {
        this.loading = false
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    }
  },

  watch: {
    async carregar() {
      if (this.carregar) {
        await this.getPendencia()
        this.$emit('carregou', false)
      }
    }
  }
}
</script>

<style lang="sass">

.pendencia-mobile > .table-cadu
  padding: 20px 10px !important
  border: none
  border-radius: 0px
  width: 100% !important

.pendencia > .table-cadu
    border: none
    border-radius: 0px
    width: 100% !important

.pendencia > .table-cadu > .table > table
    width: 100% !important

.pendencia-mobile > .table-cadu > .table > table
    width: 100% !important
</style>
